import React, { Component } from 'react';
import Icon from './Icon.js';
import './Svg.scss';
import './Icon.scss';

export default class PenIcon extends Component {
    render () {
        let finalClassName = Icon.buildCssClass(this.props);

        return (
            <svg className={finalClassName} width="24" height="24" viewBox="0 0 17 19"><path id="SvgjsPath1010" d="M687.212 295.362L683.627 295.999L682.9879999999999 292.43ZM693.784 277.008L683.97 291.02799999999996L688.1940000000001 293.96L698.008 279.94Z " transform="matrix(1,0,0,1,-682,-277)"></path></svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/icon/Pen.js